const Joi = require("joi");
const ValidationTranslateFile = require("../Loc/ValidationTranslateFile.jsx");
const currentLang = ValidationTranslateFile()

const LegalResearchRequestSchema = (data) => {

    const schema = Joi.object({
        whoSent: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Field_Required,
                "number.base": currentLang?.ValidationSchema?.Field_Required,
            }),
        information1: Joi.string()
            .trim()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Please_Enter_one_Field,
                "string.empty": currentLang?.ValidationSchema?.Please_Enter_one_Field,
            }),
        convicted: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Field_Required,
                "number.base": currentLang?.ValidationSchema?.Field_Required,
            }),
        sentenced: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Field_Required,
                "number.base": currentLang?.ValidationSchema?.Field_Required,
            }),
        researching: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Field_Required,
                "number.base": currentLang?.ValidationSchema?.Field_Required,
            }),
        proSe: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Field_Required,
                "number.base": currentLang?.ValidationSchema?.Field_Required,
            }),
        isLawyerRepresenting: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Field_Required,
                "number.base": currentLang?.ValidationSchema?.Field_Required,
            }),
        lawyerType: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Field_Required,
                "number.base": currentLang?.ValidationSchema?.Field_Required,
            }),
        specifyOther: Joi.string()
            .trim()
            .when('whoSent', {
                is: 6,
                then: Joi.string().required().messages({
                    "string.empty": currentLang?.ValidationSchema?.Please_Enter_Field,
                    "any.required": currentLang?.ValidationSchema?.Please_Enter_Field,
                }),
                otherwise: Joi.string().allow('').optional(), // Allow an empty string or ignore for other statuses
            }),
        otherState: Joi.string()
            .trim()
            .when('jurisdiction', {
                is: 7,
                then: Joi.string().required().messages({
                    "string.empty": currentLang?.ValidationSchema?.Please_Enter_Field,
                    "any.required": currentLang?.ValidationSchema?.Please_Enter_Field,
                }),
                otherwise: Joi.string().allow('').optional(), // Allow an empty string or ignore for other statuses
            }),
        jurisdiction: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Field_Required,
                "number.base": currentLang?.ValidationSchema?.Field_Required,
            }),

    }).unknown(true);

    return schema.validate(data, {
        abortEarly: false,
    });
};

module.exports = LegalResearchRequestSchema;
